module.exports = __webpack_public_path__ + "static/media/how-to-start-image-2-4.22064bbd.png";